import React from 'react';
import { useTheme } from '../../../contexts/ThemeContext';

/** Essentials-tier completion step for post-onboarding orientation. */
export default function OrientationReadyStep() {
  const { colors } = useTheme();
  return (
    <div style={{ padding: '8px 4px 12px', textAlign: 'center' }}>
      <p style={{ color: colors.text, fontSize: '0.9375rem', lineHeight: 1.55, marginBottom: 14 }}>
        Your risk rules are set up.
      </p>
      <p style={{ color: colors.textLight, fontSize: '0.9375rem', lineHeight: 1.55, margin: 0 }}>
        Use the sidebar to explore your account overview, watchlists, journals, and analytics.
      </p>
    </div>
  );
}
